
import { Link } from 'react-router-dom';
import { Button } from "@/components/ui/button";

const SearchCallToAction = () => {
  return (
    <div className="mt-16 bg-white p-6 rounded-lg shadow-md border border-gray-100">
      <div className="flex justify-center mb-4">
        <img 
          src="/lovable-uploads/81d27a38-540c-4ea0-be44-90709dcee059.png" 
          alt="Commercial Property LK Logo" 
          className="h-10 w-auto"
        />
      </div>
      <h2 className="text-2xl font-bold text-propertylk-darkblue mb-2 text-center">Not finding what you're looking for?</h2>
      <p className="text-gray-600 mb-4 text-center">
        Connect with our commercial real estate specialists in Colombo who can help you find the perfect property for your business needs.
      </p>
      <div className="flex flex-wrap gap-4 justify-center">
        <Button 
          className="bg-propertylk-blue hover:bg-propertylk-darkblue transition-colors"
          asChild
        >
          <Link to="/contact">Schedule a Consultation</Link>
        </Button>
        <Button 
          variant="outline" 
          className="border-propertylk-blue text-propertylk-blue hover:bg-propertylk-blue/10 transition-colors"
          asChild
        >
          <Link to="/register">Sign Up for Alerts</Link>
        </Button>
      </div>
    </div>
  );
};

export default SearchCallToAction;
